
import React from 'react'
import {Grid, ListItem, Tooltip,  Typography, Divider, IconButton, Collapse, List, Menu, Box } from '@mui/material'
import { Link, useLocation } from 'react-router'
// Centralized lodash imports - much cleaner!
import { isEmpty } from '@/utils/lodash'
import MoreVertOutlinedIcon from '@mui/icons-material/MoreVertOutlined'
import ChevronRightTwoToneIcon from '@mui/icons-material/ChevronRightTwoTone'
import FolderOpenTwoToneIcon from '@mui/icons-material/FolderOpenTwoTone'
import Share from '@mui/icons-material/Share'
import CreatePortfolio from '@/housefolios-components/Portfolio/CreatePortfolio'
import RemoveSharedPortfolio from '@/housefolios-components/Portfolio/RemoveSharedPortfolio'
import EditPortfolio from '@/housefolios-components/Portfolio/EditPortfolio'
import EditAssumptions from '@/housefolios-components/AssumptionsSettings/EditAssumptions'
import DuplicatePortfolio from '@/housefolios-components/Portfolio/DuplicatePortfolio'
import SharePortfolio from '@/housefolios-components/Portfolio/SharePortfolio'
import DeletePortfolio from '@/housefolios-components/Portfolio/DeletePortfolio'

import {
  sidebarActionsBtnSx,
  sidebarNavActive,
  sidebarRowActionsColSx,
  sidebarRowCountColSx,
  sidebarRowGridSx,
  sidebarRowNameSx,
  sidebarSharedSectionIconSx,
  sidebarSharedSectionLabelSx,
} from '@/layout-blueprints/chromeComponentSx'

function portfolioNavActive(isSelected, onPage) {
  return sidebarNavActive(isSelected, onPage)
}

const PortfoliosSection = (props) => {
  const {
    portfolios,
    sharedPortfolios,
    orgId,
    portfoliosDropdownOpen,
    togglePortfoliosDropdown,
    handlePortfolio,
    activePortfolioId,
    openPortfolioOptions,
    selectedPortfolio,
    canDelete,
    anchorElMenu1,
    anchorElMenu2,
    handleClosePortfolioOptions,
    ...rest
  } = props
  const onPropertiesPage = useLocation().pathname.startsWith(
    '/my-properties',
  )
  return (
  <ul>
    <li>
      <a
        id="leftNavPortfolios"
        href="#/"
        onClick={togglePortfoliosDropdown}
        data-nav-active={portfoliosDropdownOpen || undefined}
      >
        <span data-hf="sidebar-icon">
          <FolderOpenTwoToneIcon />
        </span>
        <span data-hf="sidebar-item-label">Portfolios</span>
        <span data-hf="sidebar-icon-indicator">
          <ChevronRightTwoToneIcon />
        </span>
      </a>
      <Collapse in={portfoliosDropdownOpen}>
        <ul>
          {portfolios.map((portfolio) => (
            <li
              key={portfolio._id}
              data-hf="hover-show-hide-container"
            >
              <Box sx={{
                "& [data-hf-hover=\"show\"]": { display: "none" },
                "& [data-hf-hover=\"hide\"]": { display: "block" },
                "&:hover [data-hf-hover=\"show\"]": { display: "block" },
                "&:hover [data-hf-hover=\"hide\"]": { display: "none" },
              }}>
              <Link
                onClick={() => handlePortfolio(portfolio._id)}
                to="/my-properties"
                {...portfolioNavActive(
                  String(activePortfolioId) === String(portfolio._id),
                  onPropertiesPage,
                )}
              >
                <Grid container direction="row" wrap="nowrap" sx={sidebarRowGridSx}>
                  <Grid size="grow">
                    <Typography sx={sidebarRowNameSx}>
                      {portfolio.name}
                    </Typography>
                  </Grid>
                  <Grid size="auto" data-hf-hover="hide" sx={sidebarRowCountColSx}>
                    <Typography>
                      {portfolio.propertyCount || 0}
                    </Typography>
                  </Grid>
                  <Grid
                    size="auto"
                    data-hf-grid="keep"
                    data-hf-hover="show"
                    sx={sidebarRowActionsColSx}
                  >
                    <Tooltip
                      title="Portfolio Actions"
                      slotProps={{ tooltip: { sx: {
                        bgcolor: "#4191ff",
                        "& .MuiTooltip-arrow": { color: "#4191ff" },
                      } } }}
                      arrow
                    >
                      <IconButton
                        onClick={(event) =>
                          openPortfolioOptions(
                            event,
                            portfolio,
                            portfolios.length > 1,
                          )
                        }
                        sx={sidebarActionsBtnSx}
                        size="large"
                        data-hf="sidebar-actions-btn"
                      >
                        <MoreVertOutlinedIcon />
                      </IconButton>
                    </Tooltip>
                  </Grid>
                </Grid>
              </Link>
              </Box>
            </li>
          ))}
          <CreatePortfolio sidebarMenu={true} />
          {!isEmpty(sharedPortfolios) && (
            <Box sx={sidebarSharedSectionLabelSx}>
              <Share sx={sidebarSharedSectionIconSx} />
              Shared Portfolios
            </Box>
          )}
          {sharedPortfolios.map((portfolio) => (
            <li
              key={`shared-${portfolio._id}`}
              data-hf="hover-show-hide-container"
            >
              <Box sx={{
                "& [data-hf-hover=\"show\"]": { display: "none" },
                "& [data-hf-hover=\"hide\"]": { display: "block" },
                "&:hover [data-hf-hover=\"show\"]": { display: "block" },
                "&:hover [data-hf-hover=\"hide\"]": { display: "none" },
              }}>
              <Link
                onClick={() => handlePortfolio(portfolio._id)}
                to="/my-properties"
                {...portfolioNavActive(
                  String(activePortfolioId) === String(portfolio._id),
                  onPropertiesPage,
                )}
              >
                <Grid container direction="row" wrap="nowrap" sx={sidebarRowGridSx}>
                  <Grid size="grow">
                    <Typography sx={sidebarRowNameSx}>
                      {portfolio.name}
                    </Typography>
                  </Grid>
                  <Grid size="auto" data-hf-hover="hide" sx={sidebarRowCountColSx}>
                    <Typography>
                      {portfolio.propertyCount || 0}
                    </Typography>
                  </Grid>
                  <Grid
                    size="auto"
                    data-hf-grid="keep"
                    data-hf-hover="show"
                    sx={sidebarRowActionsColSx}
                  >
                    <RemoveSharedPortfolio
                      orgId={orgId}
                      portfolioId={portfolio._id}
                      sidebarMenu
                    />
                  </Grid>
                </Grid>
              </Link>
              </Box>
            </li>
          ))}
        </ul>
      </Collapse>
    </li>
    {/* Portfolio MoreVert */}
    {selectedPortfolio && (
      <>
        <Menu
          anchorEl={anchorElMenu1}
          open={Boolean(anchorElMenu1)}
          onClose={handleClosePortfolioOptions}
          slotProps={{ list: { sx: { p: 0 } } }}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
          transformOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
          <div>
            <List
              component="div"
              sx={{
                "& .MuiListItem-root.MuiListItem-button": { borderRadius: 0 },
                "& .MuiListItem-root.MuiListItem-button.Mui-selected, & .MuiListItem-root.MuiListItem-button:hover, & .MuiListItemButton-root.Mui-selected, & .MuiListItemButton-root:hover": {
                  color: "#368cff",
                  background: "rgba(54, 140, 255, 0.05)",
                  "&::before": { background: "#368cff" },
                },
              }}
            ></List>
          </div>
        </Menu>
        <Menu
          anchorEl={anchorElMenu2}
          keepMounted
          open={Boolean(anchorElMenu2)}
          onClose={handleClosePortfolioOptions}
          slotProps={{ list: { sx: { p: 0 } } }}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
          transformOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
          <div>
            <List
              component="div"
              sx={{
                "& .MuiListItem-root.MuiListItem-button": { borderRadius: 0 },
                "& .MuiListItem-root.MuiListItem-button.Mui-selected, & .MuiListItem-root.MuiListItem-button:hover, & .MuiListItemButton-root.Mui-selected, & .MuiListItemButton-root:hover": {
                  color: "#368cff",
                  background: "rgba(54, 140, 255, 0.05)",
                  "&::before": { background: "#368cff" },
                },
              }}
              onClick={handleClosePortfolioOptions}
            >
              <EditPortfolio
                sidebarMenu={true}
                portfolio={selectedPortfolio}
              />
              <EditAssumptions
                sidebarMenu={true}
                documentId={selectedPortfolio._id}
                documentName={selectedPortfolio.name}
                defaultStrategy={selectedPortfolio.strategy}
                documentType="portfolio"
                member={rest.member}
              />
              <DuplicatePortfolio
                sidebarMenu={true}
                portfolio={selectedPortfolio}
              />
              <SharePortfolio
                sidebarMenu={true}
                portfolio={selectedPortfolio}
              />
              <Divider />
              {canDelete && (
                <DeletePortfolio
                  sidebarMenu={true}
                  portfolio={selectedPortfolio}
                  handleClose={handleClosePortfolioOptions}
                />
              )}
            </List>
          </div>
        </Menu>
      </>
    )}
  </ul>
  )
}

export default PortfoliosSection
